export default __webpack_public_path__ + "static/media/search.0d12c765.svg";